export const APPOINTMENT_HISTORY_DEFAULT_PAGE_LIMIT = 10
